/**
 * What a workspace's dashboard targets may be set to. The settings form's
 * inputs and `PATCH /workspaces/:id/kpi-targets` both read these, so the form
 * cannot offer a value the route refuses. The DEFAULTS are not here: they are
 * the `workspaces` column defaults, read by the API (`lib/kpi-targets.ts`) and
 * sent to the client as the effective values.
 */
export const KPI_TARGET_BOUNDS = {
    /** A margin or labor target band, in percent of revenue. */
    percent: { min: 0, max: 100 },
    /** The variance, in dollars over the 3-month average, at which a cost driver reads as serious. */
    costDriverAlert: { min: 0, max: 10_000_000 },
};
//# sourceMappingURL=kpi-targets.js.map